<template>
  <div>
    <div class="uc-userCenterTitle">
      <div class="left">
        <div class="icon-help">
          <div class="detail">
            <div class="detail-box">
              <h4>1. 什么是学分？</h4>
              <div class="con uc-pt5">
                学分是个人学习行为的计分体系。
              </div>
              <h4>2. 学分的用途？</h4>
              <div class="con uc-pt5">
                获取学分等级称号，参与学分排行榜排名获取奖励等。
              </div>
              <h4>3. 如何获得学分？</h4>
              <div class="con">
                <div class="uc-pt5">
                  <p>
                    完成课程、直播、培训班获取相应的学分。
                  </p>
                </div>
              </div>
              <h4>4. 如何查询我的学习学分？</h4>
              <div class="con uc-pt5">
                在 个人中心 - 我的学分 中查询学分获取明细。
              </div>
              <h4>5. 最终解释权归ITS学习中心所有。</h4>
            </div>
          </div>
        </div>
        <b>我的学分</b>
        <div class="tips">
          <span
            >累计总学分：<i class="uc-blue">{{ model.total_score || 0 }}</i>
          </span>
        </div>
      </div>
      <div class="search">
        <el-dropdown @command="handleCommand" class="uc-pl30">
          <span class="el-dropdown-link">
            {{ custom }}<i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item
              v-for="(item, index) in dropDownData"
              :key="index"
              :command="{ value: item.val, label: item.label }"
              >{{ item.label }}</el-dropdown-item
            >
          </el-dropdown-menu>
        </el-dropdown>
        <input
          type="text"
          placeholder="请输入搜索关键字"
          class="uc-input"
          v-model="query.keyword"
        />
        <a href="javascript:;" class="uc-btn blue" @click="loadData"
          ><i class="uc-font uc-search"></i
        ></a>
      </div>
    </div>

    <section class="uc-userCenterTitleTab3 bg-white">
      <div class="table">
        <table>
          <tr>
            <th style="width:10%;">序</th>
            <th style="width:30%;" class="left">获取时间</th>
            <th style="width:40%;">课程名称</th>
            <th style="width:20%;">学分数</th>
          </tr>
          <tr v-if="list.total_count == 0">
            <td colspan="10">
              <div class="content-empty">
                <div class="emptyimg-box"></div>
                <p>暂无相关内容</p>
              </div>
            </td>
          </tr>

          <tr v-for="(item, index) in list.items" :key="index">
            <td>{{ item.row }}</td>
            <td class="left">{{ item.complete_time }}</td>
            <td>{{ item.course_name }}</td>
            <td>{{ item.score }}</td>
          </tr>
        </table>
      </div>
    </section>

    <el-pagination
      class="uc-prvNxt"
      background
      layout="prev, pager, next"
      hide-on-single-page
      :current-page="query.pageIndex"
      :page-size="query.pageSize"
      :total="list.total_count"
      @current-change="handleCurrentChange"
    >
    </el-pagination>
  </div>
</template>

<script>
export default {
  name: 'StudyScore',
  data() {
    return {
      query: {
        pageIndex: 1,
        pageSize: 10,
        year: -1,
        keyword: undefined,
      },
      model: {},
      list: [],

      dropDownData: [{ label: '全部', val: -1 }],
      custom: '全部',
    };
  },

  created() {
    this.initData();
  },
  methods: {
    initData() {
      this.getMyStudyScore();
      this.getStudyScoreDetails();
      this.getYears();
    },

    handleCommand(command) {
      this.custom = command.label;
      this.query.year = command.value;
      this.query.pageIndex = 1;
      this.loadData();
    },
    loadData() {
      this.getStudyScoreDetails();
    },
    // 我的学分
    async getMyStudyScore() {
      const response = await this.$api.course.getMyStudyScore();
      this.model = response.data.data || {};
    },
    // 学分明细
    async getStudyScoreDetails() {
      const response = await this.$api.course.getStudyScoreDetails(this.query);
      this.list = response.data.data;
    },
    // 翻页
    handleCurrentChange(val) {
      this.query.pageIndex = val;
      this.loadData();
    },
    // 积分规则
    async getYears() {
      const response = await this.$api.course.getYears();
      let i = 0;
      for (const item of response.data.data) {
        this.dropDownData.push({
          label: item,
          val: item,
        });
      }
    },
  },
};
</script>
